<template>
    <div class="goods-main">
        <van-sticky
            type="primary"
        >
            <van-nav-bar
                v-if="isWechat"
                title="商品列表"
                left-text="返回"
                left-arrow
                @click-left="onGoBack"
            />
            <van-tabs
                v-if="!emptyBrandList"
                v-model="activeBrandIdx"
                @change="onTabChange"
            >
                <van-tab
                    v-for="brand in brandList"
                    :key="brand.id"
                    :title="brand.brand"
                />
            </van-tabs>
        </van-sticky>
        <!-- 商品列表 -->
        <div class="goods-main__wrapper">
            <van-list
                v-if="!emptyBrandList"
                v-model="loading"
                :finished="finished"
                finished-text='人家到底了'
                @load="loadMoreGoods"
            >
                <tic-account-card
                    v-for="sku in skuList"
                    :key="sku.id"
                    :cover-pic="sku.coverPic"
                    :sku-name="sku.skuName"
                    :raw-price="sku.rawPrice"
                    :disc-price="sku.discPrice"
                    @click.native="onSkuClick(sku.id)"
                />
            </van-list>
            <van-empty v-else description="商品为空"/>
        </div>
    </div>
</template>

<script>
    import AccountCard from '@/components/AccountCard.vue';
    import {Tab, Tabs, Tag, List, Card, NavBar, Sticky, Empty} from 'vant';
    import {navMixins, wechatMixins} from "@/mixins.js";
    import request from "@/utils/request.js";

    export default {
        name: 'Goods',
        mixins: [navMixins, wechatMixins],
        components: {
            [List.name]: List,
            [Tag.name]: Tag,
            [Card.name]: Card,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [AccountCard.name]: AccountCard,
            [NavBar.name]: NavBar,
            [Sticky.name]: Sticky,
            [Empty.name]: Empty
        },
        data() {
            return {
                activeBrandIdx: 2,
                brandList: [],
                skuList: [],
                loading: false,
                // 将加载完标志位默认为true,是避免List组件默认触发一次load事件
                finished: true,
                pageNum: 0,
                pageSize: 20,
                emptyBrandList: false
            };
        },
        async mounted() {
            // 搜索品牌列表
            await this.searchBrand(this.$route.query.categoryId);
            // 搜索商品列表
            this.loadMoreGoods();
        },
        methods: {
            resetData() {
                this.pageNum = 0;
                this.skuList = [];
                this.finished = true;
                this.loading = false;
                this.emptyBrandList = false;
            },
            onTabChange() {
                this.resetData();
                this.loadMoreGoods();
            },
            onSkuClick(skuId) {
                this.$router.push(`/sku/${skuId}`);
            },
            async searchBrand(categoryId) {
                const {response, data} = await request.post(`/customer/goods/searchSkuBrand?categoryId=${categoryId}`); 

                if (response.ok) {
                    this.brandList = data;
                }
            },
            async loadMoreGoods() {
                // 如果品牌列表为空
                if (!this.brandList ||
                    !this.brandList[this.activeBrandIdx]) {
                    this.emptyBrandList = true;
                    return;
                }
                const {response, data} = await request.post('/customer/goods/searchGoodsSku', {
                    data: {
                        pageNum: this.pageNum + 1,
                        pageSize: this.pageSize,
                        brandId: this.brandList[this.activeBrandIdx].id
                    }
                });

                this.loading = false;

                if (response.ok) {
                    this.pageNum = data.pageNum;
                    this.skuList = [...this.skuList, ...data.data];
                    this.finished = data.pages <= this.pageNum
                }
            }
        }
    }
</script>

<style lang="less">
.goods-main {
    
}

.goods-main__wrapper {
    padding-bottom: env(safe-area-inset-bottom);
    padding-bottom: constant(safe-area-inset-bottom);
}
</style>